import React from 'react';

export const StaattinenVaakagraafi = ({ title, xaxis = [], yaxis = [], values = [] }) => {
    const safe = (n) => (isFinite(parseFloat(n)) ? parseFloat(n) : 0);
    const val = values.map(safe);
    const maxValue = Math.max(...val, 0);
    const steps = 5;
    const stepSize = maxValue / steps;
    const dynamicX = Array.from({ length: steps + 1 }, (_, i) => Math.round(i * stepSize));
    const scale = maxValue > 0 ? 500 / maxValue : 1;
    const barSpacing = 55;

    return (
        <div>
            <span className="bar-chart-title">{title}</span>
            <svg width="100%" height="250px" viewBox="0,0,1000,200" style={{ marginTop: 30 }}>
                {}
                <g>
                    {val.map((v, i) => (
                        <rect
                            key={i}
                            fill={i === 0 ? "#800000" : "#bbb"}
                            x="400"
                            y={40 + i * barSpacing}
                            width={v * scale}
                            height="28"
                        />
                    ))}
                </g>

                {}
                <g textAnchor="start" fontSize="16" fontFamily="arial">
                    {val.map((v, i) => (
                        <text
                            key={i}
                            fill="black"
                            x={400 + v * scale + 10}
                            y={40 + i * barSpacing}
                            dy="18"
                        >
                            {v.toFixed(2)}
                        </text>
                    ))}
                </g>

                {} 
                <g transform="translate(0,40)" fill="none" fontSize="16" fontFamily="arial" textAnchor="middle">
                    {dynamicX.map((val, i) => (
                        <g key={i} className="tick" opacity="1" transform={`translate(${400 + (i * 100)},0)`}>
                            <line stroke="currentColor" y2="-6" />
                            <text fill="currentColor" y="-9" dy="0em">{val}</text>
                        </g>
                    ))}
                </g>

                {}
                <g transform="translate(400,0)" fill="none" fontSize="16" fontFamily="arial" textAnchor="end">
                    <path className="domain" stroke="currentColor" d="M0,40V150" />
                    {yaxis.map((label, i) => (
                        <g key={i} className="tick" opacity="1" transform={`translate(0,${55 + i * barSpacing})`}>
                            <line stroke="currentColor" x2="-6" />
                            <text fill="currentColor" x="-9" dy="0.32em">{label}</text>
                        </g>
                    ))}
                </g>
            </svg>
        </div>
    );
};
